import React from 'react';
import {PaginationButton, PaginationDots, PaginationPageButton, PaginationWrapper} from './styles';
import {ChevronLeft} from 'shared/ui/icons/chevron-left.tsx';

export type PaginationProps = {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
};

const getVisiblePages = (current: number, total: number): (number | 'dots')[] => {
  if (total <= 4) {
    return Array.from({length: total}, (_, i) => i);
  }

  if (current <= 1) {
    return [0, 1, 2, 'dots'];
  }

  if (current >= total - 2) {
    return ['dots', total - 3, total - 2, total - 1];
  }

  return [current - 1, current, current + 1, 'dots'];
};

export const Pagination = (props: PaginationProps) => {
  const {page, totalPages, onChange} = props;

  if (totalPages <= 1) return null;

  const pages = getVisiblePages(page, totalPages);

  return (
    <PaginationWrapper>
      <PaginationButton type="button" disabled={page === 0} onClick={() => onChange(page - 1)}>
        <ChevronLeft />
      </PaginationButton>

      {pages.map((item, index) =>
        item === 'dots' ? (
          <PaginationDots key={`dots-${index}`}>...</PaginationDots>
        ) : (
          <PaginationPageButton
            key={item}
            type="button"
            $active={item === page}
            onClick={() => onChange(item)}
          >
            {item + 1}
          </PaginationPageButton>
        )
      )}

      <PaginationButton
        type="button"
        disabled={page === totalPages - 1}
        onClick={() => onChange(page + 1)}
      >
        <ChevronLeft style={{transform: 'rotate(-180deg)'}} />
      </PaginationButton>
    </PaginationWrapper>
  );
};
